<script>
  export default {
    name: 'programListItem',
    props: {
      item: {
        type: Object,
        required: true
      },
      expanded: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      showProgramModal() {
        console.log('showmodal')
      }
    }
  }
</script>
<template>
  <v-list-group :append-icon="'mdi-menu-down'" :color="item.categoryColor || 'primary'" :value="expanded" no-action @input="$emit('input')">
    <template v-slot:activator>
      <v-list-item-avatar class="item-avatar ma-0">
        <v-avatar :color="item.categoryColor || 'black'" class="font-weight-bold white--text">{{ item.dayOfWeek }} <br />{{ item.dateHuman }}</v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="text-subtitle-1 font-weight-black primary--text pb-1"
          >{{ item.title }}
          <v-tooltip v-if="item.registration_enabled" color="primary" open-on-hover top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs" color="warning" x-small>mdi-file-sign</v-icon>
            </template>
            <div class="d-flex flex-column align-start">
              <span class="font-weight-bold">Requires Registration</span>
              <span class="text-caption">{{ item.registrationWindow }}</span>
            </div>
          </v-tooltip>
        </v-list-item-title>
        <v-list-item-title v-text="item.dateTimeHuman" class="text-body-2 primary--text"></v-list-item-title>
        <!-- <v-list-item-subtitle v-html="item.description || 'Please call for info.'" class="primary--text text-truncate" style="max-width: 800px"></v-list-item-subtitle> -->
        <!-- <v-icon small color="primary" class="categoryIcon">fas fa-fish</v-icon> -->
      </v-list-item-content>
    </template>

    <v-card color="transparent">
      <v-card-text class="details-text d-flex flex-column align-start justify-start">
        <template v-if="item.registrationWindow">
          <p class="detail-name text-body-2 warning--text font-weight-bold">Registration: {{ item.registrationWindow || ' -' }}</p>
        </template>

        <p v-html="item?.program_description || item?.description || 'Please call for more information.'" class="mt-2 mb-4" style="max-width: 120ch"></p>
        <v-sheet v-if="item.types?.length" class="mb-2">
          <v-chip v-for="type in item.types" :key="type.id" color="primary" small class="font-weight-bold mr-1">{{ type.text }}</v-chip>
        </v-sheet>
        <v-sheet width="100%" class="d-flex flex-row flex-lg-column align-end align-lg-start justify-space-between flex-wrap">
          <v-sheet class="flex-grow-1 mr-2">
            <p>
              <span class="detail-name text-body-1 font-weight-bold">Date:</span>
              {{ item.dateHuman || ' -' }}
            </p>
            <p>
              <span class="detail-name text-body-1 font-weight-bold">Time:</span>
              {{ item.timeStartHuman }} - {{ item.timeEndHuman }}
            </p>
            <p>
              <span class="detail-name text-body-1 font-weight-bold">Instructor:</span>
              {{ item.instructor || ' -' }}
            </p>
            <p>
              <span class="detail-name text-body-1 font-weight-bold">Location:</span>
              {{ item.location || ' -' }}
            </p>
          </v-sheet>
          <v-sheet class="pt-2">
            <v-btn color="primary" :href="item.url" target="_blank" class="mt-2">
              <v-icon left small>{{ `mdi-${item?.registration_enabled ? 'file-sign' : 'open-in-new'}` }}</v-icon>
              {{ item?.registration_enabled ? 'REGISTER / VIEW' : 'FULL DETAILS' }}
            </v-btn>
          </v-sheet>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-list-group>
</template>
<style scoped>
  .bgcolor {
    /* background-color: #ffffffc7; */
  }
  .categoryIcon {
    position: absolute;
    top: 2px;
    right: 5px;
  }
  p {
    margin-bottom: 0px;
  }

  .details-text {
    /* color: black; */
    color: var(--v-primary-base);
    /* color: white; */
  }

  .details-text p {
    color: var(--v-primary-base);
    /* color: white; */
  }

  .detail-name {
    /* color: black; */
    color: var(--v-primary-base);
    /* color: white; */
  }

  >>> .v-list-item__icon i {
    color: var(--v-primary-base);
    /* color: white; */
  }

  .item-avatar {
    height: 50px !important;
    width: 50px !important;
    margin-right: 16px !important;
  }
</style>
